import { useStore } from '@stores';
import { useEffect } from 'react';

export const useDocumentSasUrl = () => {
  const { documentStore } = useStore();
  const { documentSasUrl } = documentStore;

  useEffect(() => {
    const fetchSasUrl = async () => {
      await documentStore.getDocumentSasUrl();
    };
    fetchSasUrl();
  }, [documentStore]);

  return documentSasUrl;
};
